import { ContainerComponent, wrap } from 'AppReact';
import Controller from './controller'
import { SecondaryTextXs, BorderlessInput } from 'atoms';
import internalState from './internalState';
import { MakeReadyItemCellWrapper, Td, GenericWrapper, Px2, WordBreakWrapper } from 'wrappers';

export const definition = {
  name: 'FloatInputCell',
  controller: Controller,
  initialProps: ({ data, displayConfetti, selectedRow, showCheckboxes }) => ({ displayConfetti, data, inputValue: data?.data ?? '', selectedRow, showCheckboxes }),
  props: internalState,
  elements: [
    {
      wrapper: Td,
      name: 'Wrapper',
      renderIf: ({ selectedRow }) => !selectedRow,
      ref: ({ containerRef, isOpen }) => isOpen ? containerRef : null,
      elements: [
        {
          wrapper: MakeReadyItemCellWrapper,
          renderIf: ({ displayConfetti }) => !displayConfetti,
          name: 'Selector',
          isButton: true,
          bindings: ({ data, isOpen, containerRef, inputRef, showCheckboxes }) => ({ data, isOpen, containerRef, inputRef, showCheckboxes }),
          displayState: ({ showCheckboxes }) => ({ background: showCheckboxes ? '#F7F7F7' : '' }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextXs, WordBreakWrapper), Px2),
              name: 'Label',
              renderIf: ({ inputValue, isOpen }) => isOpen || inputValue,
              displayValue: ({ inputValue, isOpen }) => `$${inputValue && !isOpen ? inputValue : ''}`,
            },
            {
              wrapper: GenericWrapper,
              name: 'InputWrapper',
              ref: ({ inputRef }) => inputRef ?? null,
              renderIf: ({ isOpen }) => isOpen,
              elements: [
                {
                  component: BorderlessInput,
                  name: 'Input',
                  bindings: ({ inputValue }) => ({ value: inputValue, placeholder: 'Amount' }),
                  displayState: ({ }) => ({ padding: '0px 0px', minWidth: '0px' })
                }
              ]
            }
          ]
        },
      ]
    }
  ]
}

export default ContainerComponent(definition);